import React, { useState, useEffect, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import { Table, UfinetBox, UfinetButton, UfinetSectionBox, formatTableFilters, tableSortValueToSortDirection } from 'ufinet-web-components'
import { AuthContext, Authority, } from 'ufinet-web-functions'
import { colsPendingCommisions } from './PendingColData'
import { UseQueryPendingCommissions, UseDownloadFileCommissionPending } from 'request'
import { Translation } from 'utils/translation/Translation'
import BoxTotal from 'lib/box/BoxTotal'
import { DataTablePageEvent } from 'primereact/datatable'
import { CommissionKamElement } from 'types/commissionKamTypes'
import { faDownload } from '@fortawesome/free-solid-svg-icons'
import { useQueryCatalogCommissionType } from 'request/commisionKam/commision-kam-request'

const PendingPage = () => {
  const intl = useIntl()

  const [paging, setPaging] = useState<any>()
  
  const authData = useContext(AuthContext)
  const roles = authData.userData?.authorities || []
  const permissions = Authority.getCommissionKamPermissions(roles)

  const [filterData, setFilterData] = useState<any>()
  const { data: pendingCommissions, isLoading: isLoadingPendingCommission } = UseQueryPendingCommissions(filterData)

  const {data: dataCommissionType } = useQueryCatalogCommissionType()
  const colsPendingPage = useMemo(() => colsPendingCommisions({intl, dataCommissionType}), [intl, dataCommissionType])

  const cbSuccessPendingFile = (data: any) => {

  }

  const { mutate: downloadFile, isLoading: isLoadingCommissionPending } = UseDownloadFileCommissionPending(cbSuccessPendingFile)

  // To get de currencySymbol to show it at the top of the table
  const currencySymbol = pendingCommissions?.data && pendingCommissions?.data.commissions.length > 0 ? pendingCommissions?.data?.commissions[0]?.user.currencyCode : null

  useEffect(() => {
    if (pendingCommissions) {
      const parsePagination = JSON.parse(pendingCommissions?.headers['x-pagination'])
      const formattedPagination = {
        totalElements: parsePagination.totalCount,
        totalPages: parsePagination.totalPages,
        pageSize: parsePagination.pageSize,
        pageNumber: parsePagination.currentPage,
      }
      setPaging(formattedPagination)
    }
  }, [pendingCommissions])



  const onFilterClear = (): void => {
    setFilterData({})
  }

  const onFilter = (e: DataTablePageEvent): void => {
    const formattedFilters = formatTableFilters(e as any)
    setFilterData({
      ...filterData,
      ...formattedFilters
    })
  }

  const onPage = (e: DataTablePageEvent): void => {
    setFilterData({ ...filterData, pageNumber: e.page, pageSize: e.rows })
  }

  const onSort = (e: DataTablePageEvent): void => {
    const finalOrder = tableSortValueToSortDirection(e.sortOrder)
    setFilterData({
      ...filterData,
      sortField: e.sortField,
      sortOrder: finalOrder,
    })

  }

  const downloadFilePendingCommission = () => {
    downloadFile(filterData)
  }


  const getHeadersButtons = () => (
    <>
      {permissions.canWrite && (
        <UfinetButton
          className="me-3"
          icon={faDownload}
          onClick={() => downloadFilePendingCommission()}
          content={Translation('DOWNLOAD.FILE')}
        />
      )}
    </>
  )

  return (
    <>
      <UfinetBox>
        <UfinetSectionBox>
          {pendingCommissions?.data && pendingCommissions?.data?.commissions.length > 0 && (
            <BoxTotal
              title='PENDING.APPROVAL'
              totalCommissionAmount={pendingCommissions?.data?.totalCommissionAmount}
              currencyCode={currencySymbol}
            />
          )}
        </UfinetSectionBox>
        <UfinetSectionBox className='mt-5'>
          <Table
            // selectedValues={selectedValues}
            // onSelectionChange={permissions.canDelete ? onSelectionChange : undefined}
            // onRowEditComplete={permissions.canUpdate ? onRowEditComplete : undefined}
            cols={colsPendingPage}
            content={pendingCommissions?.data?.commissions?.map((item: CommissionKamElement) => ({
              ...item,
              idService: item.service.idService,
              saleMonth: item.service.saleMonth,
              commissionType: item.commission.commissionType,
              exchangeRate: item.commission.exchangeRate,
              commissionDescription: item.commission.commissionDescription,
              type: item.commission.type,
              percentageCommission: item.commission.percentageCommission,
              backlog: item.service.backlog,
              baseAmount: item.commission.baseAmount,
              authorizatorName: item.authorization.authorizatorName,
              totalAmount: item.commission.totalAmount,
              authorizatorLevel: item.authorization.authorizatorLevel,
              saleYear: item.service.saleYear,
              commissionTypePercentage: item.commission.commissionTypePercentage,
              firstBillingDate: item.service.firstBillingDate,
              percentageUser: item.commission.percentageUser,
              quoteCode: item.service.quoteCode,
            }))}
            actionBodyTemplate={<></>}
            rowsPerPageOptions={[5, 10, 20, 50, 100, 250]}
            emptyMessage={isLoadingPendingCommission || isLoadingCommissionPending ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
            onFilterClear={onFilterClear}
            lazySettings={
              paging && {
                ...paging,
                loading: isLoadingPendingCommission || isLoadingCommissionPending,
                onFilter,
                onPage,
                onSort,
              }
            }
            headerButtons={getHeadersButtons()}
          // emptyMessage={loadingRecords ? intl.formatMessage({ id: 'LOADING_DOTS' }) : undefined}
          />
        </UfinetSectionBox>
      </UfinetBox>
    </>
  )
}

export default PendingPage
